/**
 * Empty inbox placeholder for the notifications dropdown.
 */
import * as React from 'react';
import { BellOff } from 'lucide-react';
import { NOTIFICATION_EMPTY_COPY } from './notification-configs';

/** Props for {@link NotificationsEmptyState}. */
interface NotificationsEmptyStateProps {
  title?: string;
  subtitle?: string;
}

/** Empty inbox placeholder with title and subtitle. */
export const NotificationsEmptyState: React.FC<NotificationsEmptyStateProps> = ({
  title = NOTIFICATION_EMPTY_COPY.title,
  subtitle = NOTIFICATION_EMPTY_COPY.subtitle,
}) => {
  return (
    <div className="notifications-dropdown-empty">
      <div className="notifications-dropdown-empty-icon">
        <BellOff className="h-6 w-6" />
      </div>
      <div className="notifications-dropdown-empty-title">{title}</div>
      <div className="notifications-dropdown-empty-subtitle">{subtitle}</div>
    </div>
  );
};
